import { useEffect, useState } from "react";
import { useStoreState } from "../store/useStore";
import { NavAppSnapshot } from "../types";

const useNavAppSnapshot = () => {
  const { appBridge } = useStoreState();

  const [snapshot, setSnapshot] = useState<NavAppSnapshot | undefined>(() =>
    appBridge?.getSnapshot()
  );

  useEffect(() => {
    if (!appBridge) {
      setSnapshot(undefined);
      return;
    }

    const updateSnapshot = () => {
      setSnapshot(appBridge.getSnapshot());
    };

    updateSnapshot();
    return appBridge.subscribe?.(updateSnapshot);
  }, [appBridge]);

  return {
    appBridge,
    snapshot
  };
};

export default useNavAppSnapshot;
